import Mark from "./Mark.ts";
import IMark from "../interfaces/IMark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import RhColors from "@/models/RhColors.ts";
import DecodingModel from "@/models/DecodingModel.ts";
import MarkUtil from "@/utils/MarkUtil.ts";

export default class BlendMark extends Mark implements IMark
{
    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }
    
    private xFound:boolean = false;

    private _init():void
    {
        this.markWidth = 85;
        this.markHeight = 18;

        if(this.targetTextField)
        {
            this.markHeight = this.adjustToScale(36)*this.multipleOfDefaultFontSize;
            this.padding = 8;
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.markY = this.targetTextField.height/2 + (this.adjustToScale(115)*this.multipleOfDefaultFontSize);
            const code = DecodingModel.getInstance().curDecodingString;
            const index = DecodingModel.getInstance().curDecodingIndex;
            const commands = MarkUtil.getInstance().populateDecodeCommands(code);
            const len = commands.length;
            for(let i = 0; i < len; i++)
            {
                if(commands[i].position == index)
                {
                    if(commands[i].code == "x")
                    {
                        this.xFound = true;
                        this.markY = this.targetTextField.height/2 + (this.adjustToScale(150)*this.multipleOfDefaultFontSize);
                    }
                    else if(commands[i].code == "y")
                    {
                        this.markY = this.targetTextField.height/2 + (this.adjustToScale(130)*this.multipleOfDefaultFontSize);
                    }
                }
            }
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        if(this.xFound)
        {
            this.markWidth += (this.padding*2)*this.multipleOfDefaultFontSize;
        }
        const graphicsW = this.markWidth-(this.padding*2);
        const divisorW = 6;
        const divisorH = 1.4;

        let mark = new Graphics();
        mark.moveTo(0, 0);
        mark.bezierCurveTo(graphicsW/divisorW, this.markHeight*divisorH, graphicsW-(graphicsW/divisorW), this.markHeight*divisorH, graphicsW, 0);
        mark.stroke({color:color, width:this.strokeThickness, cap:"round"});
        if(this.xFound)
        {
            mark.x = (this.padding*2)*this.multipleOfDefaultFontSize;
        }
        else
        {
            mark.x = this.padding;
        }
        //mark.cacheAsBitmap = true;
        mark.visible = visible;
        this.addChild(mark);
        return mark;
    }

    public override create():void
    {
        if(this.targetTextField)
        {
            this.markX = this.markWidth/2;
        }
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}